import React from 'react'

import Navigation from '../Navigation'
import Footer from '../Footer/Footer'

import './style.css'

const Layout = ({ children }) => {
    return (
        <>
            <Navigation />
            <div className="layout">
                {children}
            </div>
            <Footer />
        </>
    )
}

export default Layout
